export default __webpack_public_path__ + "static/media/DcScreen.d4026544.png";